export default {
  zh: {
    title: 'Voca - A voice-based social app',
    recharge: '充值',
    subTitle: 'A voice-based social app',
    pageTitle: 'Simple. Fun. Diverse',
    pageDesc: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    download: 'Download',
    file: 'File',
    subTitle2: 'Chat & Party',
  },
  en: {
    title: 'Voca - A voice-based social app',
    recharge: 'Recharge',
    subTitle: 'A voice-based social app',
    pageTitle: 'Simple. Fun. Diverse',
    pageDesc: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    download: 'Download',
    file: 'File',
    subTitle2: 'Chat & Party'
  },
  ar: {
    title: 'Voca - يسكا - متن باز',
    recharge: 'شحن',
    subTitle: 'تطبيق اجتماعي يعتمد على الصوت',
    pageTitle: 'سهل. رائع. متنوع',
    pageDesc: 'باستخدام Voice Club، يمكنك التحدث وتكوين صداقات مع أشخاص من جميع أنحاء العالم، بطريقة بسيطة وموثوقة.',
    download: 'تحميل',
    file: 'ملف',
    subTitle2: 'چت و پرواز'
  },
  tr: {
    title: 'Voca - A voice-based social app',
    recharge: 'Yenileme',
    subTitle: 'Ses tabanlı sosyal uygulama',
    pageTitle: 'Basit. Güzel. Birden fazla',
    pageDesc: 'Voice Club kullanarak, dünyanın her yerindeki insanlarla konuşabilir ve arkadaşlarınızı bulabilirsiniz.',
    download: 'İndir',
    file: 'Dosya',
    subTitle2: 'Sohbet ve Parti'
  },
  pt: {
    title: 'Voca - Uma app de voz social',
    recharge: 'Recarregar',
    subTitle: 'Uma app de voz social',
    pageTitle: 'Simples. Divertido. Diverso',
    pageDesc: 'Usando o Voice Club, você pode conversar e se conectar com pessoas do mundo todo, de maneira simples e confiável.',
    download: 'Baixar',
    file: 'Arquivo',
    subTitle2: 'Bate-papo e festa'
  },
  id: {
    title: 'Voca - Aplikasi sosial berbasis suara',
    recharge: 'Isi Ulang',
    subTitle: 'Aplikasi sosial berbasis suara',
    pageTitle: 'Mudah. Menyenangkan. Beragam',
    pageDesc: 'Menggunakan Voice Club, Anda dapat berbicara dan berteman dengan orang-orang di seluruh dunia, dengan cara yang mudah dan aman.',
    download: 'Unduh',
    file: 'Berkas',
    subTitle2: 'Obrolan & Pesta'
  },
  ru: {
    title: 'Voca - Социальное приложение с голосовым интерфейсом',
    recharge: 'Пополнить',
    subTitle: 'Социальное приложение с голосовым интерфейсом',
    pageTitle: 'Простой. Развлекательный. Безграничный',
    pageDesc: 'Используя Voice Club, вы можете общаться с людьми по всему миру, в простой и надежной форме.',
    download: 'Скачать',
    file: 'Файл',
    subTitle2: 'Чат и вечеринка'
  },
  uz: {
    title: "Voca - Ishonchli davlat ro'yhatdan o'tish tizim",
    recharge: "Qayta to'ldirish",
    subTitle: "Ishonchli davlat ro'yhatdan o'tish tizim",
    pageTitle: 'Yetakchi. Imtihonli. Bepul',
    pageDesc: 'Voice Club orqali, sizda dunyada hamda boshqa davlatlardan foydalanib, oʻzingizdagi yordamchi va qulay yordamchi sizni qiziqishingiz mumkin.',
    download: 'Yuklab olish',
    file: 'Fayl',
    subTitle2: 'Chat va festival'
  },
  fa: {
    title: 'Voca - اپلیکیشن سوشیال باز',
    recharge: 'شارژ',
    subTitle: 'اپلیکیشن سوشیال باز',
    pageTitle: 'ساده. سرگرم. متنوع',
    pageDesc: 'Voice Club را برای گفت و گو کردن و دوستان خود با هم مراجعه کنید. با این کار، با دیگران همراه شوید.',
    download: 'دانلود',
    file: 'فایل',
    subTitle2: 'گفت و گو و فروشگاه'
  },
  ur: {
    title: 'Voca - یوکا - سازوکل باز',
    recharge: 'ریچارج',
    subTitle: 'یوکا - سازوکل باز',
    pageTitle: 'ساده. گنجان. متنوع',
    pageDesc: 'Voice Club کے ساتھ بیگنا بھی کے زبانوں پر آنکھیں، دنیا کے بیگنا پر آنکھیں، ساده و قدرتمند رکھیں.',
    download: 'ڈاؤن لوڈ',
    file: 'فائل',
    subTitle2: 'چت و فروشگاه'
  }
}



// WEBPACK FOOTER //
// src/pages/voca-home/lang.js